<template>
    <list
        :title="$t(`pages.${ $options.module }.list.title`)"
        :count="list.length"
        :lang="lang"
        :showNew="false"
        @language="changeLang"
    >
        <template v-slot:default>
            <list-item
                v-for="item in list"
                :key="item.id"
                :config="$options.listItemConfig"
                :state="item.state"
                @activate="activateItem(item)"
                @deactivate="deactivateItem(item)"
                @edit="editItem(item.id)"
            >
                {{ getItemTitle(item) }} <span class="small">(key: {{ item.key }})</span>
            </list-item>
        </template>
        <template v-slot:extras>
            <pop-down
                v-if="pop.active"
                :class="pop.className"
                @close="popClose"
            >
                {{ pop.message }}
            </pop-down>
        </template>
    </list>
</template>

<script>
import ListMixin from '@/components/list/ListMixin';
import PopDownMixin from '@/components/PopDownMixin';

export default {
    mixins: [ListMixin, PopDownMixin],
    name: 'InfoPagesList',
    module: 'infopages',
    listItemConfig: {
        menu: true,
        changeState: true,
        edit: true,
        delete: false,
    },
    methods: {
        compareTitles(firstEl, secondEl) {
            const firstTitle = (typeof firstEl.locales[this.lang] !== 'undefined' && typeof firstEl.locales[this.lang].title !== 'undefined')
                ? firstEl.locales[this.lang].title.toUpperCase()
                : '(empty)';
            const secondTitle = (typeof secondEl.locales[this.lang] !== 'undefined' && typeof secondEl.locales[this.lang].title !== 'undefined')
                ? secondEl.locales[this.lang].title.toUpperCase()
                : '(empty)';

            if (firstTitle < secondTitle) {
                return -1;
            }
            if (firstTitle > secondTitle) {
                return 1;
            }

            return 0;
        },
    },
};
</script>
